import { DarkTheme as theme } from "@mercedes-benz/mbui-theme";
import { deepmerge } from '@mui/utils';

const DarkThemeCustom = deepmerge(
    theme,
    {
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1024,
                xl: 1980
            }
        }, 
        cssVariables: true,
    },
    { 
        clone: true
    },
);

export { DarkThemeCustom }